import { encode, decode } from "base-64";

const serialize = (value) => JSON.stringify(value);

const deSerialize = (value) => {
  try {
    return JSON.parse(value);
  } catch (e) {
    console.error("Error in Parsing information in Object Store", e);
    return {};
  }
};

const encodeUnicode = (str) => encode(encodeURIComponent(str));
const decodeUnicode = (str) => decodeURIComponent(decode(str));

export default {
  setItem(key, value) {
    try {
      const encodedKey = encodeUnicode(key);
      const encodedValue = encodeUnicode(serialize(value));
      localStorage.setItem(encodedKey, encodedValue);
    } catch (err) {
      console.error("Error encoding data for storage:", err);
    }
  },

  getItem(key) {
    try {
      const encodedKey = encodeUnicode(key);
      const encodedValue = localStorage.getItem(encodedKey);
      if (!encodedValue) return {};
      return deSerialize(decodeUnicode(encodedValue));
    } catch (err) {
      console.error("Error decoding data from storage:", err);
      return {};
    }
  },

  removeItem(key) {
    const encodedKey = encodeUnicode(key);
    localStorage.removeItem(encodedKey);
  },

  getItemArray(key) {
    try {
      const encodedKey = encodeUnicode(key);
      const encodedValue = localStorage.getItem(encodedKey);
      if (!encodedValue) return [];
      return deSerialize(decodeUnicode(encodedValue));
    } catch (err) {
      console.error("Error decoding array from storage:", err);
      return [];
    }
  },
};
